export default __webpack_public_path__ + "static/media/python.003220f3.png";